import React, { ReactNode } from 'react';
import styled from 'styled-components';
import aspectRatioPercentage from '../../utils/aspectRatioPercentage';

interface FixedAspectProps {
  ratio?: string;
  children?: ReactNode;
}

interface OuterWrapperProps {
  percentage: number;
}

const OuterWrapper = styled.div<OuterWrapperProps>`
  position: relative;
  width: 100%;
  height: auto;
  padding-top: ${({ percentage }) => percentage}%;
  overflow: hidden;
`;

const InnerWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const FixAspect = ({ ratio = '1:1', children }: FixedAspectProps) => {
  // Calculate percentage value using 'width' and 'height'
  const percentage = aspectRatioPercentage(ratio);

  return (
    <OuterWrapper percentage={percentage}>
      <InnerWrapper>{children}</InnerWrapper>
    </OuterWrapper>
  );
};

export default FixAspect;
